import commonConfig from "../config/common";
import get from "lodash/get";

const {
  globalKeys: { sdkKey, eventBusKey }
} = commonConfig;

const getSdk = sdkName => get(window, `${sdkKey}.${sdkName}`);

const sdkExists = sdkName => !!getSdk(sdkName);

const sdkProvider = sdkName =>
  new Promise(resolve => {
    const resolveSdk = () => {
      const sdk = getSdk(sdkName);
      resolve(sdk);
    };

    if (sdkExists(sdkName)) {
      return resolveSdk();
    }

    get(window, eventBusKey).once(`${sdkName}-sdk-ready`, resolveSdk);
  });

export default sdkProvider;
